import React from "react";
import { Toolbar } from "primereact/toolbar";
import "./Footer.scss";

const Footer: React.FC = () => {
	const startContent = (
		<div className="footer-left">
			<a>
				User Guide
			</a>
		</div>
	);

	// const endContent = (
	// 	<div className="footer-right">
	// 		<span className="version-text">v0.4.8</span>
	// 	</div>
	// );

	return (
		<Toolbar
			className="footer-toolbar"
			start={startContent}
			// end={endContent}
		/>
	);
};

export default Footer;